export default "__VITE_ASSET__DwmRH26p__"